import React from 'react';

import { Button } from '../../components/Button/Button';
import { useInView } from '../../hooks/useInView';
import type { CtaBlock } from './slides';

import './CtaBlockSection.css';

type CtaBlockSectionProps = {
    data: CtaBlock;
};

export function CtaBlockSection({ data }: CtaBlockSectionProps) {
    const [ref, inView] = useInView<HTMLDivElement>();

    return (
        <section className="fb-cta-block">
            <div
                ref={ref}
                className={`fb-cta-block__inner faves-reveal-group${inView ? ' faves-reveal-group--in' : ''}`}
            >
                {data.backgroundImage && (
                    <img className="fb-cta-block__bg" src={data.backgroundImage} alt="" aria-hidden="true" loading="lazy" />
                )}
                <div className="fb-cta-block__overlay" aria-hidden="true" />
                <div className="fb-cta-block__content">
                    {data.eyebrow && (
                        <span className="fb-cta-block__eyebrow faves-eyebrow--uppercase faves-reveal">{data.eyebrow}</span>
                    )}
                    <h2
                        className="fb-cta-block__heading faves-display faves-reveal"
                        style={{ '--reveal-delay': '100ms' } as React.CSSProperties}
                    >
                        {data.heading}
                    </h2>
                    <span
                        className="faves-reveal"
                        style={{ '--reveal-delay': '200ms' } as React.CSSProperties}
                    >
                        <Button
                            label={data.cta.label}
                            href={data.cta.href}
                            variant="accent"
                            className="fb-cta-block__cta"
                        />
                    </span>
                </div>
            </div>
        </section>
    );
}
